import { Checkbox, PanelType } from '@fluentui/react';
import { Label } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataChampMetier } from '../../data/DataChampMetier.jsx';
import { MaxLengths } from '../../data/MaxLenghts.jsx';
import { Immocom } from '../../specifique/immocom';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class FicheChampMetier extends Component {

    static defaultProps = {
        idChampMetier: undefined,
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onSave: () => null
    };

    static defaultState = {
        champMetier: {
            checkbox: false,
            description: "",
            exemple: "",
            libelleV2: "",
            libelleV4: "",
            nomChamp: "",
            nomTable: "",
            prefix: "",
            requeteSQL: "",
            stringFormat: "",
            type: "",
        },
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheChampMetier.defaultState };
        this.deferredValidation = window.setTimeout(null);
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement en cours...'
        });

        const { idChampMetier } = this.props;

        DataChampMetier._detailler(idChampMetier).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const champMetier = responseFetch.reponseAPIobjet;
                const state = { champMetier };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _update = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    };

    _onOpen = () => {
        const { idChampMetier } = this.props;
        this.setState({ ...FicheChampMetier.defaultState });
        if (!!idChampMetier)
            this._chargementDonnees();
    };

    _onSave = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du champMetier en cours'
        });

        const { onSave } = this.props;
        const { champMetier } = this.state;

        DataChampMetier._enregistrer(champMetier).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onSave);
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onVerificationFormulaire = () => {
        const state = { ...this.state.champMetier };
        Immocom.fiche()._validationFormulaire(this, 'ChampMetier', state, (this.state.champMetier.idChampMetier > 0 ? 'Modification' : 'Création'));
    };

    _updateChampMetier = (values) => {
        const champMetier = { ...this.state.champMetier, ...values };
        this.setState({ champMetier }, () => {
            window.clearTimeout(this.deferredValidation);
            this.deferredValidation = window.setTimeout(this._onVerificationFormulaire, 500);
        });
    };

    render = () => {

        const { idChampMetier, isOpen, onDismiss } = this.props;
        const { champMetier, onActiveBoutonEnregistrer } = this.state;

        return <EUIPanel
            headerText={!!idChampMetier ? `Modification de la balise #${idChampMetier}` : "Nouvelle balise"}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._onSave}
            type={PanelType.medium}
        >

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <div className="ms-Grid" dir="ltr">

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <EUITextField
                            label="Champ"
                            maxLength={MaxLengths.champMetier.nomChamp}
                            onChange={(event, newValue) => this._updateChampMetier({ nomChamp: newValue })}
                            required
                            value={champMetier.nomChamp}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <Label>Case à cocher</Label>
                        <Checkbox
                            checked={champMetier.checkbox}
                            onChange={(e, isChecked) => this._updateChampMetier({ checkbox: isChecked })}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <EUITextField
                            label="Table"
                            maxLength={MaxLengths.champMetier.nomTable}
                            onChange={(event, newValue) => this._updateChampMetier({ nomTable: newValue })}
                            required={!champMetier.prefix}
                            value={champMetier.nomTable}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <EUITextField
                            label="Prefixe"
                            maxLength={MaxLengths.champMetier.prefix}
                            onChange={(event, newValue) => this._updateChampMetier({ prefix: newValue })}
                            required={!champMetier.nomTable}
                            value={champMetier.prefix}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <EUITextField
                            label="Libellé v4"
                            maxLength={MaxLengths.champMetier.libelleV4}
                            onChange={(event, newValue) => this._updateChampMetier({ libelleV4: newValue })}
                            value={champMetier.libelleV4}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <EUITextField
                            label="Libellé v2"
                            maxLength={MaxLengths.champMetier.libelleV2}
                            onChange={(event, newValue) => this._updateChampMetier({ libelleV2: newValue })}
                            value={champMetier.libelleV2}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <EUITextField
                            label="SQL"
                            maxLength={MaxLengths.champMetier.requeteSQL}
                            multiline
                            onChange={(event, newValue) => this._updateChampMetier({ requeteSQL: newValue })}
                            rows={8}
                            value={champMetier.requeteSQL}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <EUIComboBox
                            idValeurParDefaut="0"
                            label="Type"
                            onChange={(event, option) => this._updateChampMetier({ type: option.key })}
                            options={[
                                { key: "Boolean", text: "Booléen" },
                                { key: "DateTime", text: "Date" },
                                { key: "Decimal", text: "Décimal" },
                                { key: "Int32", text: "Entier" },
                                { key: "String", text: "Texte" },
                            ]}
                            required
                            selectedKey={champMetier.type}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg6">
                        <EUIComboBox
                            idValeurParDefaut="0"
                            label="Format"
                            onChange={(event, option) => this._updateChampMetier({ stringFormat: option.key })}
                            options={[
                                { key: "{0:0.00}", text: "Deux décimales" },
                                { key: "{0:0.000}", text: "Trois décimales" },
                                { key: "{0:C}", text: "Monétaire" },
                            ]}
                            selectedKey={champMetier.stringFormat}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <EUITextField
                            label="Description"
                            maxLength={MaxLengths.champMetier.description}
                            multiline
                            onChange={(event, newValue) => this._updateChampMetier({ description: newValue })}
                            rows={8}
                            value={champMetier.description}
                        />
                    </div>
                </div>

                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <EUITextField
                            label="Exemple"
                            maxLength={MaxLengths.champMetier.exemple}
                            onChange={(event, newValue) => this._updateChampMetier({ exemple: newValue })}
                            value={champMetier.exemple}
                        />
                    </div>
                </div>

            </div>

        </EUIPanel>;
    };

};